﻿package com.mgacreative.hotelru.domain.model

import kotlinx.serialization.Serializable

@Serializable
data class Staff(
    val id: String = "",
    val tenant_id: String = "",
    val user_id: String? = null,
    val full_name: String = "",
    val department: String = ""
)

